const submission = require('./submission');
const submissionUpload = require ('./submissionUpload');

module.exports = {
	submission,
	submissionUpload,
};
